import { ActivatedRoute } from '@angular/router';
import { StopBidComponent } from './../../components/stop-bid/stop-bid.component';
import { GetSecondHandSuppliesService } from './../../services/get-second-hand-supplies.service';
import { LoginData } from '../../../../../../core/models/login-data';
import { LoginService } from 'src/app/core/services/login.service';
import { ToastService } from './../../../../../../core/toast.service';
import { DeleteMultipleComponent } from './../../components/delete-multiple/delete-multiple.component';
import { SendForApprovalComponent } from './../../components/send-for-approval/send-for-approval.component';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ViewReasonComponent } from './../../components/view-reason/view-reason.component';
import { MatDialog } from '@angular/material/dialog';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { FormBuilder, Validators, AbstractControl, FormArray } from '@angular/forms';
import { switchMap } from 'rxjs/operators';
import { RejectComponent } from '../../components/reject/reject.component';
import { ApproveComponent } from '../../components/approve/approve.component';
import { DeleteComponent } from '../../components/delete/delete.component';
import { ActiveComponent } from '../../components/active/active.component';
import { InactiveComponent } from '../../components/inactive/inactive.component';
import { Filter } from 'src/app/core/models/filter';
import { PageEvent } from '@angular/material/paginator';
import { GetSupplyCategoriesService } from '../../services/get-supply-categories.service';
import { GetSupplySubCategoriesService } from '../../services/get-supply-sub-categories.service';
import { GetSupplyBrandsService } from '../../services/get-supply-brands.service';
import { SendForApprovalMultipleComponent } from '../../components/send-for-approval-multiple/send-for-approval-multiple.component';
import { Sort } from '@angular/material/sort';
import { SecondHandSupply } from '../../models/second-hand-supply';
import { ApproveMultipleComponent } from '../../components/approve-multiple/approve-multiple.component';
@Component({
  selector: 'app-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.scss'],
  animations: [
    trigger("openCloseFilter", [
      state('true', style({ height: '*', opacity: '1' })),
      state('false', style({ height: '0px', opacity: '0' })),
      transition("false <=> true", [animate(500)])
    ])
  ],
  providers: [
    GetSupplyCategoriesService,
    GetSupplySubCategoriesService,
    GetSupplyBrandsService
  ]
})
export class ListingComponent implements OnInit, OnDestroy {
  columnList: any = [
    /*{
      column: "sku",
      title: "Sku",
      operators: [
        { title: "Contains", operator: "_ilike" },
      ],
      type: "text",
    },*/
    {
      column: "supply_category_id",
      title: "Select category",
      operators: [
        { title: "Equals", operator: "_eq" },
      ],
      tableName: "supply_categories",
      type: "select",
    },
    {
      column: "supply_sub_category_id",
      title: "Select sub category",
      operators: [
        { title: "Equals", operator: "_eq" },
      ],
      tableName: "supply_sub_categories",
      type: "select",
    },
    {
      column: "supply_brand_id",
      title: "Select brand",
      operators: [
        { title: "Equals", operator: "_eq" },
      ],
      tableName: "supply_brands",
      type: "select",
    }
  ];
  operatorList = [];
  filterForm = this.fb.group({
    status: ['APPROVED', [Validators.required]],
    search: ['', [Validators.required]],
    limit: [50, [Validators.required]],
    filters: this.fb.array([]),
    sort: [[{ "updated_at": "desc" }]],
    offset: [0, [Validators.required]]
  });
  totalElements = 0;
  filterSubject: BehaviorSubject<Filter>;
  /* --------------------------------- FIELDS -------------------------------- */
  // FILTER-FUNCTIONALITIES
  openFilter = false;
  displayedColumns: string[] = ['select', 'title', 'category', 'sub_category', 'brand', 'bid_starts_at', 'bid_ends_at', 'action'];
  dataSource: MatTableDataSource<SecondHandSupply>;
  statusWiseCount: any;
  selection = new SelectionModel<SecondHandSupply>(true, []);
  loginData: LoginData;
  supplyCategoriesList: any[];
  filterObj: any = {};
  subscription: Subscription;
  /* ------------------------------- CONSTRUCTOR ------------------------------ */
  constructor(
    private _dialog: MatDialog,
    private fb: FormBuilder,
    private getSecondHandSupplyService: GetSecondHandSuppliesService,
    private toast: ToastService,
    private loginService: LoginService,
    private getSupplyCategoriesService: GetSupplyCategoriesService,
    private getSupplySubCategoriesService: GetSupplySubCategoriesService,
    private getSupplyBrandsService: GetSupplyBrandsService,
    private route: ActivatedRoute
  ) {
    if(this.route.snapshot.paramMap.get('status')){
      this.status.setValue(this.route.snapshot.paramMap.get("status"));
    }
    this.loginData = this.loginService.getLoginData();
    if (this.loginData.type === 'ADMIN') {
      this.columnList.push({
        column: "dental_supplier.name",
        title: "Business owner",
        operators: [
          { title: "Contains", operator: "_ilike" },
        ],
        type: "text"
      });
      this.columnList.push({
        column: "dental_practice.name",
        title: "Dental Practitioner",
        operators: [
          { title: "Contains", operator: "_ilike" },
        ],
        type: "text"
      });
      this.columnList.push({
        column: "dental_professional.name",
        title: "Dental Professional",
        operators: [
          { title: "Contains", operator: "_ilike" },
        ],
        type: "text"
      });
      this.displayedColumns = ['select', 'title', 'supplier', 'category', 'sub_category', 'brand', 'bid_starts_at', 'bid_ends_at', 'action'];
    } else {
      this.displayedColumns = ['select', 'title', 'category', 'sub_category', 'brand', 'bid_starts_at', 'bid_ends_at', 'action'];
    }
    this.filterSubject = new BehaviorSubject<Filter>(this.filterForm.value);
  }
  /* ----------------------------- NG-LIFE-CYCLES ----------------------------- */
  ngOnInit(): void {
    this.subscription = this.filterSubject.pipe(switchMap(filter => {
      this.dataSource = null;
      return this.getSecondHandSupplyService.getSecondHandSupplies(filter);
    })).subscribe(([second_hand_supplies, count, statusWiseCount]: [SecondHandSupply[], number, any]) => {
      this.dataSource = new MatTableDataSource<SecondHandSupply>(second_hand_supplies);
      this.totalElements = count;
      this.statusWiseCount = statusWiseCount;
    });
    this.filterObj.supply_categories = this.getSupplyCategoriesService.getSupplyCategories();
    this.filterObj.supply_sub_categories = this.getSupplySubCategoriesService.getSupplySubCategories();
    this.filterObj.supply_brands = this.getSupplyBrandsService.getSupplyBrands();
  }
  ngOnDestroy(){
    this.subscription.unsubscribe();
  }
  /* ------------------------------ CUSTOM-METHODS ----------------------------- */
  filterToggle(): void {
    this.openFilter = !this.openFilter;
    if (this.openFilter && this.filters.length === 0) {
      this.plusField();
    }
  }
  clearFilters() {
    this.openFilter = false;
    this.filters.clear();
    this.filterSubject.next(this.filterForm.value);
  }
  plusField() {
    this.filters.push(this.getField());
  }
  minusField(i: number) {
    this.filters.removeAt(i);
  }
  getField() {
    return this.fb.group({
      column: [null, [Validators.required]],
      operator: [null, [Validators.required]],
      value: [null, [Validators.required]]
    })
  }
  filterChange() {
    this.filterSubject.next(this.filterForm.value);
  }
  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    if (this.dataSource) {
      const numSelected = this.selection.selected.length;
      const numRows = this.dataSource.data.length;
      return numSelected === numRows;
    } else {
      return false;
    }
  }
  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.dataSource) {
      this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach(row => this.selection.select(row));
    }
  }
  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: SecondHandSupply): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row`;
  }
  viewReason(secondHandSupply: SecondHandSupply) {
    this._dialog.open(ViewReasonComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: secondHandSupply
    })
  }
  sendForApprovalDialog(secondHandSupply: SecondHandSupply) {
    const dialogRef = this._dialog.open(SendForApprovalComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: secondHandSupply
    });
    dialogRef.afterClosed().subscribe(status => {
      console.log(status);
      if (status === 'yes') {
        this.filterSubject.next(this.filterForm.value);
      }
      if (status === 'no') {
      }
    })
  }
  rejectDialog(secondHandSupply: SecondHandSupply) {
    const dialogRef = this._dialog.open(RejectComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: secondHandSupply
    });
    dialogRef.afterClosed().subscribe(status => {
      console.log(status);
      if (status === 'yes') {
        this.filterSubject.next(this.filterForm.value);
      }
      if (status === 'no') {
      }
    })
  }
  approveDialog(secondHandSupply: SecondHandSupply) {
    const dialogRef = this._dialog.open(ApproveComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: secondHandSupply
    });
    dialogRef.afterClosed().subscribe(status => {
      console.log(status);
      if (status === 'yes') {
        this.filterSubject.next(this.filterForm.value);
      }
      if (status === 'no') {
      }
    })
  }
  stopBidingDialog(secondHandSupply: SecondHandSupply) {
    const dialogRef = this._dialog.open(StopBidComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: secondHandSupply
    });
    dialogRef.afterClosed().subscribe(status => {
      console.log(status);
      if (status === 'yes') {
        this.filterSubject.next(this.filterForm.value);
      }
      if (status === 'no') {
      }
    })
  }
  deleteDialog(secondHandSupply: SecondHandSupply) {
    const dialogRef = this._dialog.open(DeleteComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: secondHandSupply
    });
    dialogRef.afterClosed().subscribe(status => {
      console.log(status);
      if (status === 'yes') {
        this.filterSubject.next(this.filterForm.value);
      }
      if (status === 'no') {
      }
    })
  }
  approveMultipleDialog() {
    if (this.selection.selected.length === 0) {
      this.toast.openSnackBar("Please select pre owned supplies to delete");
      return;
    }
    const idArray = this.selection.selected.map(single => single.id);
    const dialogRef = this._dialog.open(ApproveMultipleComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: idArray
    });
    dialogRef.afterClosed().subscribe(status => {
      console.log(status);
      if (status === 'yes') {
        this.selection.clear();
        this.filterSubject.next(this.filterForm.value);
      }
      if (status === 'no') {
      }
    })
  }
  sendForApprovalMultipleDialog() {
    if (this.selection.selected.length === 0) {
      this.toast.openSnackBar("Please select pre owned supplies to send for approval");
      return;
    }
    const idArray = this.selection.selected.map(single => single.id);
    const dialogRef = this._dialog.open(SendForApprovalMultipleComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: idArray
    });
    dialogRef.afterClosed().subscribe(status => {
      console.log(status);
      if (status === 'yes') {
        this.selection.clear();
        this.filterSubject.next(this.filterForm.value);
      }
      if (status === 'no') {
      }
    })
  }
  deleteMultipleDialog() {
    if (this.selection.selected.length === 0) {
      this.toast.openSnackBar("Please select pre owned supplies to delete");
      return;
    }
    const idArray = this.selection.selected.map(single => single.id);
    const dialogRef = this._dialog.open(DeleteMultipleComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: idArray
    });
    dialogRef.afterClosed().subscribe(status => {
      console.log(status);
      if (status === 'yes') {
        this.selection.clear();
        this.filterSubject.next(this.filterForm.value);
      }
      if (status === 'no') {
      }
    })
  }
  activeDialog(secondHandSupply: SecondHandSupply) {
    const dialogRef = this._dialog.open(ActiveComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: secondHandSupply
    });
    dialogRef.afterClosed().subscribe(status => {
      console.log(status);
      if (status === 'yes') {
        this.filterSubject.next(this.filterForm.value);
      }
      if (status === 'no') {
      }
    })
  }
  inactiveDialog(secondHandSupply: SecondHandSupply) {
    const dialogRef = this._dialog.open(InactiveComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: secondHandSupply
    });
    dialogRef.afterClosed().subscribe(status => {
      console.log(status);
      if (status === 'yes') {
        this.filterSubject.next(this.filterForm.value);
      }
      if (status === 'no') {
      }
    })
  }
  searchProductByName() {
    this.filterSubject.next(this.filterForm.value);
  }
  setStatus() {
    this.filterSubject.next(this.filterForm.value);
  }
  /* --------------------------------- Getters -------------------------------- */
  /* ------------------------------- FilterForm ------------------------------- */
  get search() {
    return this.filterForm.get('search');
  }
  get sort() {
    return this.filterForm.get('sort');
  }
  get status(): AbstractControl {
    return this.filterForm.get("status");
  }
  get limit(): AbstractControl {
    return this.filterForm.get('limit');
  }
  get offset(): AbstractControl {
    return this.filterForm.get('offset');
  }
  get filters(): FormArray {
    return this.filterForm.get('filters') as FormArray;
  }
  changePage(ev: PageEvent) {
    this.offset.setValue(ev.pageSize * ev.pageIndex);
    this.filterSubject.next(this.filterForm.value);
  }
  setFilter(single: AbstractControl) {
    single.get('operator').setValue(single.get('column').value.operators[0].operator);
  }
  sortData(ev: Sort) {
    if (!ev.direction) {
      this.sort.setValue([{ "updated_at": "desc" }]);
      this.filterSubject.next(this.filterForm.value);
    }
    switch (ev.active) {
      case "title":
        this.sort.setValue([{ "title": ev.direction }]);
        break;
      case "category":
        this.sort.setValue([{ "supply_category": { "name": ev.direction } }]);
        break;
      case "sub_category":
        this.sort.setValue([{ "supply_sub_category": { "name": ev.direction } }]);
        break;
      case "brand":
        this.sort.setValue([{ "supply_brand": { "name": ev.direction } }]);
        break;
      default:
        this.sort.setValue([{ "updated_at": "desc" }]);
    }
    this.filterSubject.next(this.filterForm.value);
  }
}
